module.exports = __webpack_public_path__ + "static/img/home_banner2.c8878297.png";